<template>
    <div class="tree-node-wrapper" @click.stop="onNodeClick" @contextmenu.prevent.stop="onNodeRightClick" :data-id="treeData.id" :data-type="treeData.type" :class="[{opened:isOpened()},{leaf:!isParent}]" >
        <div class="tree-node-inner" :class="[{active:isActive()},levelClass]" :title="treeData.name">
            <div class="bg"></div>
            <span class="tree-node-content"><i class="fa fa-caret-right caret" @click.stop="toggleNodeOpen" v-if="isParent"></i><span class="handler"><i class="fa-fw" :class="typeIcon"></i>{{ treeData.name }}</span></span>
        </div>
        <ul :id="treeNodeClass" v-if="treeData.children" :style="openedHeight" >
            <draggable :list="treeData.children" :element="'li'" class="tree-node" :options="options" @start="handleStart" @end="handleEnd" :move="handleMove" :data-id="treeData.id" :data-type="treeData.type" >
            <treenode v-for="node in treeData.children" :key="node.id" :treeData="node" :options="options" :level="nextLevel" :icons="icons"
                      :sortHandler="sortHandler" :moveHandler="moveHandler" :clickHandler="clickHandler" :rightClickHandler="rightClickHandler"></treenode>
            </draggable>
        </ul>

    </div>
</template>

<script>
    import Vue from 'vue';
    import Sortable from 'sortablejs';

    import draggable from 'vuedraggable'
    import state from '@/services/PlanTreeState'

    import denseModeMixin from '@/mixins/denseMode.js'

    export default {
        components: {
            draggable
        },
        name: 'treenode',
        props: {
            treeData: [Object],
            options: {
                type: [Object],
                default: function(){
                    return {
                        sortable: false,
                        keepActivate: true,
                        constrain: true
                    }
                }
            },
            sortHandler: [Function],
            moveHandler: [Function],
            clickHandler: [Function],
            rightClickHandler: [Function],
            level: [Number],
            icons: {
                type: [Object],
                default: function(){
                    return {}
                }
            }
        },
        computed: {
            nextLevel: function () {
                return this.level + 1;
            },
            levelClass: function () {
                return 'level-'+this.level;
            },
            openedHeight: function(){
                if(this.treeData.opened) {

                    return 'height: ' + (this.calcHeight(this.treeData)*(this.denseMode ? 24 : 42)) + 'px;';
                }
                return '';
            },
            treeNodeClass: function(){
                return 'tree-node-'+this.treeData.id;
            },
            typeIcon: function(){
                return this.icons[this.treeData.type];
            },
            isParent: function(){
                if(this.treeData.children && this.treeData.children.length > 0){
                    return true;
                }
                return false;
            }
        },
        data () {
            return {}
        },
        created: function () {

            Vue.util.defineReactive(this.treeData, 'active', state.active == this.treeData.id);
             Vue.util.defineReactive(this.treeData, 'opened', state.opened[this.treeData.id]);
        },
        mixins: [denseModeMixin],
        mounted: function () {
        },
        methods: {
            isActive: function(){
                return this.treeData.active;

            },
            isOpened: function(){
                return this.treeData.opened;
            },
            handleStart: function(evt){
                evt.target.classList.add('sorting-activate');
                document.getElementsByClassName('tree-main-node')[0].classList.add('sorting');
            },
            handleEnd: function(evt){
                document.getElementsByClassName('tree-main-node')[0].classList.remove('sorting');
                evt.target.classList.remove('sorting-activate');
                this.sortHandler(evt);
            },
            handleMove: function(evt){
                this.moveHandler(evt);
            },
            onNodeClick: function () {
                if(this.options.keepActivate)
                    this.treeData.active = true;
                //this.treeData.$set('active', true);
                //this.treeData.splice('active', 1, true)
                this.clickHandler(this.treeData);
                this.$emit('nodeClick', this.treeData);

            },
            onNodeRightClick: function (e) {
                if(this.treeData.type != 7)
                {
                    this.rightClickHandler(e,this.treeData);
                }

            },
            toggleNodeOpen: function(){
                this.treeData.opened = !this.treeData.opened;
                state.opened[this.treeData.id] = this.treeData.opened;
            },
            calcHeight: function(node){

                if(node.children && node.children.length > 0){
                    var childrenHeight = 0;
                    for(var child in node.children){
                        if(node.children[child].opened)
                        {
                            childrenHeight += this.calcHeight(node.children[child]);
                        }
                    }
                    return node.children.length + childrenHeight;
                }
                return 0;
            },

        },
        watch: {
            treeData: function(){

                if(state.opened[this.treeData.id] == null){
                    state.opened[this.treeData.id] = false;
                }

                Vue.util.defineReactive(this.treeData, 'active', false);
                Vue.util.defineReactive(this.treeData, 'opened', state.opened[this.treeData.id]);

                this.calcHeight(this.treeData);


            }
        }
    }
</script>

